import { useEffect } from 'react';
import { useTranslations } from '../../i18n';

interface SEOProps {
    title?: string;
    description?: string;
}

export function SEO({ title, description }: SEOProps) {
    const { t } = useTranslations();

    useEffect(() => {
        // Use provided title or fall back to default from translations
        const baseTitle = 'My Car Costs';
        const pageTitle = title || t.landing?.hero?.title;
        document.title = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;

        // Manage meta description
        const defaultDescription = t.landing?.hero?.description || 'Ultimate car expense tracking and maintenance logging app.';
        const metaDescription = document.querySelector('meta[name="description"]');
        
        if (metaDescription) {
            metaDescription.setAttribute('content', description || defaultDescription);
        } else {
            const meta = document.createElement('meta');
            meta.name = 'description';
            meta.content = description || defaultDescription;
            document.head.appendChild(meta);
        }

        // Manage OG tags for social sharing
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', pageTitle || baseTitle);
        
        const ogDesc = document.querySelector('meta[property="og:description"]');
        if (ogDesc) ogDesc.setAttribute('content', description || defaultDescription);

    }, [title, description, t]);

    return null;
}
